import { gql } from "@apollo/client";

export const GET_PICKUP_RECEIVERS = gql`
  mutation GetPickupReceivers($sellerID: ID!) {
    pickupReceiver {
      list(sellerID: $sellerID) {
        id
        fullName
        phone
      }
    }
  }
`;

export const CREATE_PICKUP_RECEIVER = gql`
  mutation CreatePickupReceiver($sellerID: ID!, $input: PickupReceiverInput!) {
    pickupReceiver {
      create(sellerID: $sellerID, input: $input) {
        id
        fullName
        phone
      }
    }
  }
`;

export const UPDATE_PICKUP_RECEIVER = gql`
  mutation UpdatePickupReceiver($id: ID!, $input: PickupReceiverInput!) {
    pickupReceiver {
      update(id: $id, input: $input) {
        id
        fullName
        phone
      }
    }
  }
`;

export const DELETE_PICKUP_RECEIVER = gql`
  mutation DeletePickupReceiver($id: ID!) {
    pickupReceiver {
      delete(id: $id)
    }
  }
`;

export const UPDATE_ORDER_PICKUP = gql`
  mutation UpdateOrderPickup($request: UpdateOrderInput!) {
    sellerOps {
      order {
        update(request: $request)
      }
    }
  }
`;
